export const dealStages = ["Won", "Lost", "Conversation", "Pipeline", "Scheduled", "Other"];
